import Image from 'app/Components/Shared/Image/image';
import React, {useCallback} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, setCategoryData} from 'app/Components/Block/VisualIVRMenuBlock/VisualIVRSlice';
import {visualIvrSteps} from 'app/Components/Block/VisualIVRMenuBlock/utils/constants';
import Config from 'app/Config';

const IvrCategory = ({category, setCurrentStep, setCategoryData}) => {
  const {categoryName, categoryIconUrl} = category || {};

  const categoryIconFullUrl = categoryIconUrl ? Config.epiBaseUrl + categoryIconUrl : '';

  const handleCategoryClick = () => {
    setCategoryData(category);
    setCurrentStep(visualIvrSteps.CATEGORY_ACTIONS_PAGE);
  };

  return (
    categoryName && (
      <div className='ivr-category-container' onClick={handleCategoryClick}>
        {categoryIconFullUrl && <Image className='ivr-category-icon' src={categoryIconFullUrl} />}
        <span className='ivr-category-name'>{categoryName}</span>
      </div>
    )
  );
};

const mapDispatchToProps = {
  setCurrentStep,
  setCategoryData,
};

export default connect(null, mapDispatchToProps)(IvrCategory);
